// extracted by mini-css-extract-plugin
module.exports = {"category":"enllac_category__bGTVr","boto":"enllac_boto__IqPP6"};